import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { UploaderComponent } from './uploader.component';
import { DropZoneDirective } from './drop-zone.directive';
import { TreatImageDirective } from './treat-image.directive';

@NgModule({
  imports: [
    CommonModule,
  ],
  declarations: [
    UploaderComponent,
    DropZoneDirective,
    TreatImageDirective,
  ],
  exports: [
    UploaderComponent,
    DropZoneDirective,
    TreatImageDirective,
  ]
})
export class UploaderModule { }
